<template>
  <el-row>
    <el-col :span="6" class="cs-contentContainer-left">
      <div>&nbsp;</div>
    </el-col>
    <el-col :span="12" class="cs-fullHeight cs-contentContainer-middle">
      <div class="cs-fullHeight-content">
        <div class="backgroud-white cs-content-main">
          <div>
            <el-row>
              <el-col>
                <img v-if="status === 'success'" src="@/assets/success.png" />
                <img v-else src="@/assets/disabled.png" />
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <h4>付款{{status === 'success' ? '成功' : "失败"}}</h4>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="6" class="cs-contentContainer-right">
      <div>&nbsp;</div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "paymentResponse",
  data() {
    return {
      merchantOrderId: null,
      status: null,
    };
  },
  created() {
    let { order_id, status } = this.$route.query;
    this.merchantOrderId = order_id;
    this.status = status;
    if (this.status === "success") {
      this.sendMsg(true, this.merchantOrderId);
    }
  },
  methods: {
    sendMsg(success, merchantOrderId) {
      window.parent.postMessage(
        {
          cmd: "checkpay",
          params: {
            success,
            merchantOrderId,
          },
        },
        "*"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-contentContainer-middle {
  display: flex;
  justify-content: center;
  align-items: center;

  .cs-fullHeight-content {
    width: 100%;

    .cs-content-main {
      height: 500px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-row {
        padding: 30px;

        .el-col {
          text-align: center;
        }
      }
    }

    .cs-content-bottom {
      height: 60px;

      footer {
        line-height: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/payApi/checkpayPaymentResponse.vue